export default __webpack_public_path__ + "static/media/goshen10.2edeccce.jpg";